var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2698 9.5185C1.99044 10 2.99362 10 5 10C7.00637 10 8.0095 10 8.73025 9.5185C9.04212 9.31 9.31 9.04212 9.5185 8.73025C10 8.0095 10 7.00637 10 5C10 2.99362 10 1.99044 9.5185 1.2698C9.31 0.957824 9.04212 0.689963 8.73025 0.481513C8.0095 3.72529e-08 7.00637 0 5 0C2.99362 0 1.99044 3.72529e-08 1.2698 0.481513C0.957824 0.689963 0.689975 0.957824 0.481513 1.2698C3.72529e-08 1.99044 0 2.99362 0 5C0 7.00637 3.72529e-08 8.0095 0.481513 8.73025C0.689975 9.04212 0.957824 9.31 1.2698 9.5185Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cbcdb971f584f29b9b8fc194dc48ffc1.svg";
export { ForwardRef as ReactComponent };